<template>
    <div class="notes-filter-widget">
        <div class="filter-left-panel-section">
            <div class="notes-filter-header">
                <div class="filter-page-title">Notes</div>
                <div class="filter-title">Filters</div>
            </div>

            <!-- Time Section -->
            <div class="filter-section">
                <button class="calendar-toggle" @click="toggleCalendarSection" ref="calendar_select_widget_trigger">
                    <img src="@/assets/icons/calendar-line.svg" class="toggle-icon">
                </button>

                <div v-if="dateRange.startDate" class="selected-date">
                    <span>{{ dateRange.startDate }} - {{
                        dateRange.endDate }}</span>
                    <button class="btn-remove-date" @click="resetAllFilters">
                        <img src="@/assets/icons/close__ic.svg">
                    </button>
                </div>

                <div class="quick-filters">
                    <button class="quick-filter" :class="{ active: filters.quickFilter === 'last-week' }"
                        @click="selectQuickFilter('last-week')">Last week</button>
                    <button class="quick-filter" :class="{ active: filters.quickFilter === 'yesterday' }"
                        @click="selectQuickFilter('yesterday')">Yesterday</button>
                    <button class="quick-filter" :class="{ active: filters.quickFilter === 'today' }"
                        @click="selectQuickFilter('today')">Today</button>
                </div>

                <div v-if="showCalendarSection" class="calendar-section" ref="calendar_select_widget" v-closable="{
                    exclude: ['calendar_select_widget_trigger', 'calendar_select_widget'],
                    handler: 'hideCalendarSection',
                }">
                    <div class="calendar-grid">
                        <functional-calendar class="calendar" v-model="calendarData" :is-date-range="true"
                            :is-dark='false'>
                            <template v-slot:footer>
                                <div class="calendar-footer">
                                    <widgetButton @click="applyCalendarFilters" :loading="false" class="btn-secondary">
                                        Apply Dates
                                    </widgetButton>
                                </div>
                            </template>
                        </functional-calendar>
                    </div>
                </div>
            </div>

            <!-- People Section -->
            <div class="filter-section has-divider">
                <div class="people-trigger-section-header" ref="people_select_widget_trigger"
                    @click="togglePeopleListSection">
                    <h3>People</h3>
                    <div class="people-list">
                        <div v-for="person in visibleSelectedPeople" :key="person.id" class="person-item"
                            :class="{ active: filters.selectedPeople.includes(person.id) }">
                            <widgetProfile :title="person.name" subtitle="" :showContent="false" :size="18"
                                :text_size="6" file_name="" path="" :enableRightMargin="false" @click="">
                            </widgetProfile>
                        </div>
                        <div v-if="remainingPeopleCount > 0" class="person-item more">
                            +{{ remainingPeopleCount }}
                        </div>
                        <button v-if="!selectedPeopleList.length" class="add-people-btn">
                            Select People
                        </button>
                    </div>
                    <button class="people-type-toggle">
                        <img src="@/assets/icons/arrow_down_black.svg" class="toggle-icon">
                    </button>
                </div>

                <div v-if="showPeopleListSection" class="peoples-list-widget" ref="people_select_widget" v-closable="{
                    exclude: ['people_select_widget_trigger', 'people_select_widget'],
                    handler: 'hidePeopleListSection',
                }">
                    <widgetListSelecter v-model="people_list" @confirm="(data) => {
                        showPeopleListSection = false;
                        onPeopleSelected(data);
                    }" :useTemplate="true" @close="showPeopleListSection = false">
                        <template v-slot:item="{ item }">
                            <div class="people-list-item">
                                <widgetProfile :title="item.name" subtitle="" :size="20" :text_size="8" file_name=""
                                    path="">
                                </widgetProfile>
                            </div>
                        </template>
                    </widgetListSelecter>
                </div>
            </div>

            <!-- show only Note  Section -->
            <div class="filter-section has-divider">
                <widgetCheckbox v-model="filters.viewNotesOnly" title="View Notes only" @change="toggleViewNotesOnly">
                </widgetCheckbox>
            </div>

            <div class="filter-section">
                <widgetButton @click="resetAllFilters()" :loading="false" class="btn-transparent-secondary">
                    Reset All Filters
                </widgetButton>
            </div>
        </div>

        <div class="filter-right-panel-section">
            <widgetButton @click="addNewNote()" :loading="false" class="btn-primary">
                Add New +
            </widgetButton>
        </div>
    </div>
</template>

<script>
import { FunctionalCalendar } from 'vue-functional-calendar';
export default {
    name: 'NotesFilter',
    components: {
        FunctionalCalendar
    },
    computed: {
        selectedPeopleList() {
            return this.people_list.filter(person => this.filters.selectedPeople.includes(person.value));
        },
        visibleSelectedPeople() {
            return this.selectedPeopleList.slice(0, 3);
        },
        remainingPeopleCount() {
            return Math.max(0, this.selectedPeopleList.length - 3);
        }
    },
    data() {
        return {
            calendarData: {},
            showCalendarSection: false,
            showNoteTypesSection: false,
            showPeopleListSection: false,
            dateRange: {
                startDate: null,
                endDate: null
            },
            filters: {
                dateRange: [],
                quickFilter: null,
                noteTypes: [],
                selectedPeople: [],
                viewNotesOnly: false
            },
            people_list: []
        }
    },
    mounted() {
        let vm = this;
        vm.getPeopleList();
        vm.resetAllFilters();
    },
    methods: {
        getPeopleList() {
            let vm = this;
            vm.$store.dispatch("ACCOUNT_GET_NOTES_PEOPLE", {
                account_id: vm.$route.params.id
            }).then((response) => {
                vm.people_list = response.data.map((item) => {
                    return {
                        value: item.user_id,
                        name: item.first_name + ' ' + item.last_name,
                        checked: vm.filters.selectedPeople.includes(item.id)
                    };
                });
            });
        },
        emitFilterChange() {
            this.$emit('filter-change', { ...this.filters })
        },
        togglePeopleListSection() {
            this.showPeopleListSection = !this.showPeopleListSection
        },
        hidePeopleListSection() {
            this.showPeopleListSection = false
        },
        toggleNoteTypesSection() {
            this.showNoteTypesSection = !this.showNoteTypesSection
        },
        hideNoteTypesSection() {
            this.showNoteTypesSection = false
        },
        toggleCalendarSection() {
            this.showCalendarSection = !this.showCalendarSection
        },
        hideCalendarSection() {
            this.showCalendarSection = false
        },
        addNewNote() {
            this.$emit('add')
        },
        selectQuickFilter(filter) {
            let vm = this;
            this.filters.quickFilter = filter
            const today = new Date()

            switch (filter) {
                case 'today':
                    this.filters.dateRange = [
                        today.toLocaleDateString(),
                        today.toLocaleDateString()
                    ]
                    this.dateRange = {
                        startDate: today.toLocaleDateString(),
                        endDate: today.toLocaleDateString()
                    }
                    break
                case 'yesterday':
                    const yesterday = new Date(today)
                    yesterday.setDate(yesterday.getDate() - 1)
                    this.filters.dateRange = [
                        yesterday.toLocaleDateString(),
                        yesterday.toLocaleDateString()
                    ]
                    this.dateRange = {
                        startDate: yesterday.toLocaleDateString(),
                        endDate: yesterday.toLocaleDateString()
                    }
                    break
                case 'last-week':
                    const lastWeek = vm.moment().subtract(1, 'weeks').startOf('week')
                    const endOfWeek = vm.moment().subtract(1, 'weeks').endOf('week')
                    this.filters.dateRange = [
                        lastWeek.format('MM/DD/YYYY'),
                        endOfWeek.format('MM/DD/YYYY')
                    ]
                    this.dateRange = {
                        startDate: lastWeek.format('DD/MM/YYYY'),
                        endDate: endOfWeek.format('DD/MM/YYYY')
                    }
                    break
            }
            this.emitFilterChange()
        },
        toggleNoteType(type) {
            const index = this.filters.noteTypes.indexOf(type)
            if (index === -1) {
                this.filters.noteTypes = [type]
            } else {
                this.filters.noteTypes = []
            }
            this.showNoteTypesSection = false;
            this.emitFilterChange()
        },
        togglePerson(id) {
            const index = this.filters.selectedPeople.indexOf(id)
            if (index === -1) {
                this.filters.selectedPeople.push(id)
            } else {
                this.filters.selectedPeople.splice(index, 1)
            }
            this.emitFilterChange()
        },
        applyCalendarFilters() {
            this.showCalendarSection = false;
            this.filters.dateRange = [
                this.calendarData.dateRange.start,
                this.calendarData.dateRange.end
            ]
            this.dateRange = {
                startDate: this.calendarData.dateRange.start,
                endDate: this.calendarData.dateRange.end
            }
            this.emitFilterChange()
        },
        onPeopleSelected(data) {
            this.filters.selectedPeople = data;
            this.showPeopleListSection = false;
            this.emitFilterChange()
        },
        toggleViewNotesOnly() {
            this.emitFilterChange()
        },
        resetAllFilters() {
            this.filters = {
                dateRange: [],
                quickFilter: null,
                noteTypes: [],
                selectedPeople: [],
                viewNotesOnly: false
            }
            this.dateRange = {
                startDate: null,
                endDate: null
            }
            this.emitFilterChange()
        }
    }
}
</script>

<style lang="scss" scoped>
.notes-filter-widget {
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    padding: 10px;
    border-radius: 5px;
    width: 100%;
    height: 100%;

    .filter-left-panel-section {
        display: flex;
        flex-direction: row;

        .notes-filter-header {
            display: flex;
            align-items: center;
            margin-right: 30px;

            .filter-page-title {
                font-size: 15px;
                color: rgba(0, 0, 0, 1);
                font-weight: bold;
                margin: 0px;
                border-right: 1px solid rgba(235, 238, 242, 1);
                padding-right: 20px;
                margin-right: 20px;
            }

            .filter-title {
                font-size: 13px;
                color: rgba(152, 162, 178, 1);
                margin: 0px;
            }
        }

        .filter-section {
            display: flex;
            align-items: center;
            gap: 10px;
            position: relative;

            &.has-divider {
                border-right: 1px solid rgba(235, 238, 242, 1);
                padding-right: 20px;
                margin-right: 20px;
            }

            .calendar-toggle {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 30px;
                height: 30px;
                border-radius: 5px;
                cursor: pointer;
                border: 1px solid rgba(96, 108, 128, 0.05);
            }

            .selected-date {
                background-color: rgba(8, 132, 175, 0.83);
                border-radius: 5px;
                padding: 4px 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 4px;
                color: #fff;
                position: relative;

                .btn-remove-date {
                    position: absolute;
                    right: -8px;
                    top: -9px;
                    background-color: rgba(219, 39, 42, 1);
                    border-radius: 50%;
                    width: 20px;
                    height: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    border: none;
                    padding: 2px;
                    margin: 0px;

                    img {
                        width: 10px;
                        height: 10px;
                    }
                }
            }

            .calendar-section {
                position: absolute;
                top: 20px;
                left: 0px;
                width: 100%;
                background-color: #fff;
                z-index: 1000;
                padding: 10px;
                border-radius: 5px;
                box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
                display: flex;
            }

            .quick-filters {
                display: flex;
                gap: 8px;
                margin: 16px 0px;
                border-right: 1px solid rgba(235, 238, 242, 1);
                padding-right: 20px;
                margin-right: 20px;

                .quick-filter {
                    padding: 3px 6px;
                    border-radius: 20px;
                    border: 1px solid #e0e0e0;
                    background: rgba(8, 132, 175, 0.11);
                    cursor: pointer;
                    transition: all 0.2s;

                    &.active {
                        background: #3498db;
                        color: white;
                        border-color: #3498db;
                    }
                }
            }

            .calendar-section {
                margin-top: 12px;
                padding: 0px 10px;
                display: flex;
                flex-direction: column;

                .calendar-grid {
                    margin-bottom: 16px;

                    .calendar {
                        .vfc-main-container {
                            box-shadow: none !important;
                        }
                    }

                    .calendar-footer {
                        display: flex;
                        justify-content: center;
                        margin-top: 10px;
                        width: 100%;
                    }
                }


            }

            .section-header {
                h3 {
                    margin: 0px;
                }
            }

            .people-trigger-section-header {
                cursor: pointer;
                display: flex;
                align-items: center;
                gap: 10px;

                .people-list {
                    display: flex;
                    align-items: center;

                    .person-item {
                        display: flex;
                        align-items: center;
                        padding: 4px;
                        border-radius: 14px;
                        cursor: pointer;
                        transition: background-color 0.2s;
                        background-color: #fff;

                        &:not(:first-child) {
                            margin-left: -10px;
                        }

                        &:hover {
                            background-color: #f5f5f5;
                        }

                        &.active {
                            background-color: #e3f2fd;
                        }

                        &.more {
                            background: rgba(242, 244, 247, 1);
                            color: rgba(96, 108, 128, 1);
                            width: 25px;
                            height: 25px;
                            border-radius: 50%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 12px;
                            margin-left: -10px;
                        }
                    }

                    .add-people-btn {
                        padding: 4px 12px;
                        border-radius: 20px;
                        border: 1px solid #e0e0e0;
                        background: #fff;
                        color: #606c80;
                        cursor: pointer;
                        font-size: 12px;

                        &:hover {
                            background-color: #f5f5f5;
                        }
                    }
                }

                .people-type-toggle {
                    position: relative;
                    left: -10px;
                }
            }

            .peoples-list-widget {
                position: absolute;
                top: 25px;
                left: 0px;
                width: 100%;
                min-width: 200px;
                background-color: #fff;
                z-index: 1000;
                padding: 10px;
                border-radius: 5px;
                box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);

            }


            .note-type-toggle {
                display: flex;
                align-items: center;
                gap: 4px;
                cursor: pointer;
                padding: 4px 8px;
                border: 1px solid #e0e0e0;
                border-radius: 20px;
                background: #fff;
                min-width: 100px;

                span {
                    margin-right: 5px;
                    color: #606c80;
                }

                .selected-note-type {
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    font-size: 12px;
                    text-transform: capitalize;
                    margin-right: 5px;

                    &.reminder {
                        color: #e57373;
                    }

                    &.call {
                        color: #ffb74d;
                    }

                    &.meeting {
                        color: #64b5f6;
                    }

                    &.task {
                        color: #4db6ac;
                    }

                    &.history {
                        color: #9e9e9e;
                    }

                    .remove-note-type {
                        width: 14px;
                        height: 14px;
                        padding: 2px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border: none;
                        background: none;
                        cursor: pointer;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }

                .toggle-icon {
                    margin-left: auto;
                }
            }

            .note-types {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                gap: 8px;
                padding: 0px 10px;
                margin-bottom: 10px;
                position: absolute;
                top: 25px;
                left: 0px;
                width: 100%;
                background-color: #fff;
                z-index: 1000;
                padding: 10px;
                border-radius: 5px;
                box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);

                .note-type {
                    padding: 3px 8px;
                    border-radius: 20px;
                    border: none;
                    cursor: pointer;
                    transition: all 0.2s;

                    &.reminder {
                        color: #e57373;
                    }

                    &.call {
                        color: #ffb74d;
                    }

                    &.meeting {
                        color: #64b5f6;
                    }

                    &.task {
                        color: #4db6ac;
                    }

                    &.history {
                        color: #9e9e9e;
                    }

                    &.active {
                        filter: brightness(0.9);
                    }

                    &:hover {
                        background-color: #f5f5f5;
                    }
                }
            }



        }
    }

    .filter-right-panel-section {
        display: flex;
        align-items: center;
    }
}
</style>

<style lang="scss">
.calendar-section {
    .calendar-grid {
        .calendar {
            .vfc-main-container {
                box-shadow: none !important;
            }

            .vfc-calendar .vfc-content {
                margin: 0px !important;
            }

            .vfc-week .vfc-day span.vfc-span-day.vfc-today {
                background-color: #fff !important;
                color: #000 !important;
            }
        }
    }
}
</style>
